var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"admin-default"}},[_vm._v(" Select Client from the list ")])
}
var staticRenderFns = []

export { render, staticRenderFns }